import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, TimePicker} from '@material-ui/pickers';
import LinearProgress from '@material/react-linear-progress';
import React, {useState} from 'react';
import MealHeavy from '../../assets/icons/meal/meal-heavy-black.svg';
import MealLight from '../../assets/icons/meal/meal-light-black.svg';
import MealModerate from '../../assets/icons/meal/meal-moderate-black.svg';
import {
  getLocalStorage,
  localStorageKey,
} from '../../common/localStorageHandler';
import {editMeal} from '../../rest-api/home-api/meal';
import PrimaryButton from '../common/buttons/button-primary/button-primary';
import ErrorMessage from '../common/errors/error-message';
import TextArea from '../common/textarea/textarea';
import PlainTextBoxWithLabel from '../common/textboxes/plain-textbox/plain-textbox';

const mealSizeOptions = [
  {
    icon: MealLight,
    label: 'Light',
    size: 1,
  },
  {
    icon: MealModerate,
    label: 'Moderate',
    size: 2,
  },
  {
    icon: MealHeavy,
    label: 'Heavy',
    size: 3,
  },
];

export default function EditMeal(props) {
  const {close, afterSubmitMethod, params} = props;
  const {timestamp, mealId, mealSizeId, details} = params.object;
  const [isSubmiting, setSubmiting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isTimePickerOpened, openTimePicker] = useState(false);
  const [selectedTime, setTime] = useState(new Date(Number(timestamp)));
  const [mealSize, setMealSize] = useState(Number(mealSizeId));
  const [editDetails, setDetails] = useState(details);

  const MealRadioButtons = (props) => {
    const {icon, size, label} = props;
    return (
      <div className="add-meal-radio">
        <input
          checked={size === mealSize}
          onChange={() => setMealSize(size)}
          className="radio-button"
          name="radio"
          type="radio"
        />
        <img className="ml-1" src={icon} alt="radio-icon" />
        <span className="ml-1">{label}</span>
      </div>
    );
  };

  const updateMeal = (e) => {
    e.preventDefault();
    setSubmiting(true);
    setErrorMessage('');
    afterSubmitMethod('');
    const userId = getLocalStorage(localStorageKey.USERID);
    const body = {
      userId: userId,
      size: mealSize,
      timestamp: selectedTime.getTime(),
      details: editDetails,
      mealId: mealId,
    };

    editMeal(body)
      .then((res) => {
        console.log('got response ', res);
        const {message} = JSON.parse(res.data.editMeals.body);
        if (res.data.editMeals.statusCode === 200) {
          close();
          afterSubmitMethod(message);
        } else {
          throw new Error(message);
        }
      })
      .catch((e) => setErrorMessage(e.message))
      .then(() => setSubmiting(false));
  };

  const getTime = () => {
    if (selectedTime.getHours() > 12) {
      return (
        ('0' + (selectedTime.getHours() - 12)).slice(-2) +
        ' : ' +
        ('0' + selectedTime.getMinutes()).slice(-2) +
        ' PM'
      );
    } else {
      return (
        ('0' + selectedTime.getHours()).slice(-2) +
        ' : ' +
        (' 0' + selectedTime.getMinutes()).slice(-2) +
        ' AM'
      );
    }
  };

  const changeTime = (value) => {
    setErrorMessage('');
    const currentTimeStamp = new Date().getTime();
    if (currentTimeStamp < value.getTime()) {
      setErrorMessage("You can't enter future time");
    } else {
      setTime(value);
    }
  };

  return (
    <>
      <div className="add-contact-container">
        <div className="add-contact-header">
          <div className="add-contact-header-text">Edit Meal</div>
          <i
            className="fa fa-close"
            onClick={close}
            style={{color: 'dodgerblue', cursor: 'pointer'}}
          />
        </div>
        {isSubmiting && <LinearProgress indeterminate={true} />}
        <div className={isSubmiting ? 'pre-authentication-disable-div' : ''}>
          <form onSubmit={editMeal}>
            <div className="add-contact-body">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  label="12 hours"
                  value={selectedTime}
                  open={isTimePickerOpened}
                  onClose={() => openTimePicker(false)}
                  onChange={changeTime}
                  TextFieldComponent={() => (
                    <div className="mt-1">
                      <PlainTextBoxWithLabel
                        classes="add-meal-textbox"
                        value={getTime()}
                        label="Time"
                        click={() => openTimePicker(true)}
                      />
                    </div>
                  )}
                />
              </MuiPickersUtilsProvider>

              <div className="add-meal-size-option mt-1">
                <span className="textarea-label" style={{marginLeft: 0}}>
                  Size of Meal
                </span>
                {mealSizeOptions.map((obj, i) => (
                  <MealRadioButtons
                    key={i}
                    label={obj.label}
                    icon={obj.icon}
                    size={obj.size}
                  />
                ))}
              </div>
              <div className="textarea-label">Details</div>
              <div style={{width: '97%'}}>
                <TextArea
                  value={editDetails}
                  changeValue={setDetails}
                  placeholder="Add notes"
                />
              </div>
              <div className="add-contact-text-box">
                <PrimaryButton
                  disable={false}
                  labelInAction="Updating ..."
                  isInAction={isSubmiting}
                  label="Update"
                  classes="add-contact-downdown"
                  click={updateMeal}
                />
              </div>
              {errorMessage.length > 0 && (
                <ErrorMessage
                  classes="add-contact-text-box-input"
                  message={errorMessage}
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
